import React from 'react';
import QueryContext, { AuthProvider } from './QueryContext';

interface QueryProviderProps {
  authProvider: AuthProvider;
  children: React.ReactNode;
}

const QueryProvider = ({
  authProvider,
  children,
}: QueryProviderProps): React.ReactElement | null => {
  return (
    <QueryContext.Provider
      value={{
        authProvider,
      }}
    >
      {children}
    </QueryContext.Provider>
  );
};

export default QueryProvider;
